import { useEffect, useState, useMemo } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useToken } from '../../hooks/useToken'
import * as creditAPI from '../../sdk/credit'
import { GetUserProfileOutput, getUserProfile } from '../../sdk/user'
import './Verify.css'
import { Locale } from '../../components/Locale'
import { usePageLayout } from '../../hooks/usePageLayout'

function SubscriptionVerify() {
  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: 'Subscription Verification',
    }),
    [],
  )

  // Verification page should show all navigation elements
  usePageLayout(layoutOptions)

  let navigate = useNavigate()
  const { token } = useToken()
  const [error, setError] = useState<string | null>(null)
  const [subscription_id, setSubscriptionId] = useState<number>(0)
  const [subscription_status, setSubscriptionStatus] = useState<string | null>(
    null,
  )
  const [profile, setProfile] = useState<GetUserProfileOutput | null>(null)

  useEffect(() => {
    //From server ingest
    let url = new URL(window.location.href)
    setSubscriptionId(parseInt(url.searchParams.get('subscription_id')!))
    setSubscriptionStatus(url.searchParams.get('subscription_status'))
    setError(url.searchParams.get('error'))

    //If not logged in, redirect to login page
    if (!(subscription_id > 0 && token)) {
      // !Unhide after bugfix
      setTimeout(() => {
        navigate('/Login')
      }, 45000)
    } else {
      //Used to recheck the value if the initial status is pending after the ingest from the server
      async function check_status(_subscription_id: number) {
        let json = await creditAPI.subscriptionStatus({
          params: { subscription_id: _subscription_id },
        })
        setSubscriptionStatus(json.subscription_status)
      }

      getUserProfile({}).then(setProfile)

      let retry_counter = 0
      let max_retries = 5

      const recheck_status_interval = setInterval(() => {
        check_status(subscription_id)
        retry_counter++
        if (retry_counter >= max_retries || subscription_status !== 'Pending') {
          clearInterval(recheck_status_interval)
        }
      }, 30000)
      return () => {
        clearInterval(recheck_status_interval)
      }
    }
  }, [token, error, subscription_id, subscription_status])

  return (
    <>
      <div className="body Verify">
        <div
          style={{
            textAlign: 'center',
            position: 'absolute',
            top: '50%',
            color: 'white',
          }}
          className="reg-container"
        >
          {token && profile ? (
            <div>
              <div>
                <Locale
                  en={`Subscription ID: #${subscription_id}`}
                  zh_cn={`订阅 ID: #${subscription_id}`}
                  zh_hk={`訂閱 ID: #${subscription_id}`}
                />
              </div>
              <div>
                <Locale
                  en={`Subscription Status: ${subscription_status}`}
                  zh_cn={`订阅狀態: ${subscription_status}`}
                  zh_hk={`訂閱狀態: ${subscription_status}`}
                />
              </div>
              <Link to="/profile" className="primary-button">
                <Locale
                  en="Go to Profile"
                  zh_cn="前往个人资料"
                  zh_hk="前往個人資料"
                />
              </Link>
            </div>
          ) : (
            <h2>Error: {error}</h2>
          )}
        </div>
      </div>
    </>
  )
}

export default SubscriptionVerify
